module.exports = __webpack_public_path__ + "img/contact_6.eb92233f.png";